<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create an Email Template
          </h2>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="isShowURL"
      width="55%"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">URL</h3></template
      >
      <div><URLTable /></div>
    </el-dialog>
    <div class="bg-white py-10 menucontrol-scroll fixed-top px-20">
      <div class="flex justify-around items-center gap-4">
        <div class="w-3/5 flex justify-start">
          <div class="flex items-center justify-end">
            <p class="col-4f text-xl cross mb-0 whitenowrap font-semibold">
              Preview
            </p>
          </div>
          <div class="w-3/5">
            <div class="bg-3a3a3a p-8 rounded-10px">
              <div class="rounded-6px bg-f4f5f6 h-32">
                <img
                  :src="
                    this.image1Source
                      ? image1Source
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/admin/assets/brained-landscape.png'
                  "
                  class="w-full rounded-md object-cover h-full"
                  alt="image1"
                />
              </div>

              <div class="mt-6">
                <div class="flex">
                  <div class="w-1/4">
                    <div class="rounded-6px bg-f4f5f6 h-24">
                      <img
                        :src="
                          this.image2Source
                            ? image2Source
                            : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/admin/assets/bained-square.png'
                        "
                        class="w-full rounded-md object-cover h-full"
                        alt="image2"
                      />
                    </div>
                  </div>

                  <div class="w-3/4 pl-4">
                    <!-- <p class="text-white fsize12">
                      Make your emails pop with an attractive banner. Make your
                      emails pop with an attractive banner.
                    </p> -->
                    <p class="text-white fsize12" v-html="body1"></p>
                  </div>
                </div>

                <div class="flex mt-6">
                  <div class="w-1/4">
                    <div class="rounded-6px bg-f4f5f6 h-24">
                      <img
                        :src="
                          this.image3Source
                            ? image3Source
                            : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/admin/assets/bained-square.png'
                        "
                        class="w-full rounded-md object-cover h-full"
                        alt="image3"
                      />
                    </div>
                  </div>

                  <div class="w-3/4 pl-4">
                    <!-- <p class="text-white fsize12">
                      Make your emails pop with an attractive banner. Make your
                      emails pop with an attractive banner.
                    </p> -->
                    <p class="text-white fsize12" v-html="body2"></p>
                  </div>
                </div>
                <div class="mt-6">
                  <p class="text-white mb-1">Thankyou,</p>
                  <p class="text-white">
                    {{ this.selectedProject.displayName }}
                  </p>
                </div>
              </div>

              <div class="mt-10">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
                  alt="instagram"
                  class="w-4 mr-4 h-4 object-contain cursor-pointer"
                />

                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
                  alt="youtube"
                  class="w-4 mr-4 h-4 object-contain cursor-pointer"
                />

                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
                  alt="facebook"
                  class="w-4 mr-4 h-4 object-contain cursor-pointer"
                />

                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
                  alt="twitter"
                  class="w-4 mr-4 h-4 object-contain cursor-pointer"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
                  alt="whatsapp"
                  class="w-4 mr-4 h-4 object-contain cursor-pointer"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
                  alt="linkedin"
                  class="w-4 mr-4 h-4 object-contain cursor-pointer"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/admin/assets/pintrest.png"
                  alt="pinterest"
                  class="w-4 mr-4 h-4 object-contain cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg-white w-2/5 h-530px cust-shadow rounded-10px px-8 pt-8 pb-16 relative"
        >
          <div class="smslayouts-h pr-2" v-if="!isshowform">
            <div>
              <h6 class="col-4f text-xl mb-0">Template Name</h6>
              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="templateName"
              ></el-input>
              <p
                v-if="submitted == true || checkform1 === true"
                class="fsize12 text-danger"
              >
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
            </div>
            <!-- <div class="mt-6">
              <h6 class="col-4f text-xl mb-0">Template Type</h6>

              <el-select
                v-model="value"
                placeholder="Select"
                multiple
                class="w-full mt-2"
              >
                <el-option
                  v-for="item in templateTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->

            <div class="mt-6">
              <h6 class="col-4f text-lg mb-0">Subject</h6>

              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="subject"
              ></el-input>
              <p
                v-if="submitted == true || checkform1 === true"
                class="fsize12 text-danger"
              >
                {{ subject === "" ? "This Field is required" : "" }}
              </p>
            </div>

            <div class="mt-6">
              <div class="flex justify-between w-full mb-3 items-center">
                <h6 class="col-4f text-lg mb-0">Body Text</h6>
                <p
                  class="text-sm underline text-primary cursor-pointer"
                  @click="isShowURL = true"
                >
                  Landing Page
                </p>
              </div>
              <!-- <el-input
                placeholder="Enter..."
                class="mt-2 w-full textarea-h100px"
                v-model="bodyText"
                type="textarea"
              ></el-input> -->
              <vue-editor id="body1" class="quill-height" v-model="body1" />
              <p
                v-if="submitted == true || checkform1 === true"
                class="fsize12 text-danger"
              >
                {{
                  body1 === ""
                    ? "This Field is required"
                    : "" || body1.length <= 35
                    ? "You need to enter 25 characters"
                    : ""
                }}
              </p>
            </div>
            <div class="mt-6">
              <h6 class="col-4f text-lg mb-0">Body Text</h6>

              <!-- <el-input
                placeholder="Enter..."
                class="mt-2 w-full textarea-h100px"
                v-model="bodyText"
                type="textarea"
              ></el-input> -->
              <vue-editor id="body2" class="quill-height" v-model="body2" />
              <p
                v-if="submitted == true || checkform1 === true"
                class="fsize12 text-danger"
              >
                {{
                  body2 === ""
                    ? "This Field is required"
                    : "" || body2.length <= 35
                    ? "You need to enter 25 characters"
                    : ""
                }}
              </p>
            </div>
          </div>
          <div v-if="isshowform">
            <h6 class="col-4f text-xl mb-0">Image (Banner)</h6>

            <div
              class="bg-aeaeae relative rounded-12px mt-6 p-5 flex items-center"
              :class="image1Source !== '' ? 'bg-light-green' : ''"
            >
              <feather-icon
                icon="UploadIcon"
                svgClasses="w- h-6"
                class="text-white"
                :class="image1Source !== '' ? 'text-success' : ''"
              />
              <p
                class="text-white fsize12 mb-0 pl-2"
                :class="image1Source !== '' ? 'text-success' : ''"
              >
                Upload an image in png,jpeg or jpg format.
              </p>
              <input
                type="file"
                class="opacity-0 absolute w-full h-full"
                @change="uploadImage1"
                :accept="['image/jpg', 'image/jpeg', 'image/png']"
              />
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ image1 === "" ? "This Field is required" : "" }}
              </p>
            </div>

            <p class="text-8f8f8f pt-4 fsize12">
              Need Help with Email Banners?
              <span
                class="text-primary font-semibold cursor-pointer"
                @click="
                  () => {
                    this.$router.push({ path: '/admin-panel/studio' });
                  }
                "
                >Visit Studio</span
              >
            </p>

            <div>
              <h6 class="col-4f text-xl mb-0 mt-8">Image</h6>

              <div
                class="bg-aeaeae relative rounded-12px mt-6 p-5 flex items-center"
                :class="image2Source !== '' ? 'bg-light-green' : ''"
              >
                <feather-icon
                  icon="UploadIcon"
                  svgClasses="w- h-6"
                  class="text-white"
                  :class="image2Source !== '' ? 'text-success' : ''"
                />
                <p
                  class="text-white fsize12 mb-0 pl-2"
                  :class="image2Source !== '' ? 'text-success' : ''"
                >
                  Upload an image in png,jpeg or jpg format.
                </p>
                <input
                  type="file"
                  class="opacity-0 absolute w-full h-full"
                  @change="uploadImage2"
                  :accept="['image/jpg', 'image/jpeg', 'image/png']"
                />
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ image2 === "" ? "This Field is required" : "" }}
                </p>
              </div>

              <div
                class="bg-aeaeae relative rounded-12px mt-4 p-5 flex items-center"
                :class="image3Source !== '' ? 'bg-light-green' : ''"
              >
                <feather-icon
                  icon="UploadIcon"
                  svgClasses="w- h-6"
                  class="text-white"
                  :class="image3Source !== '' ? 'text-success' : ''"
                />
                <p
                  class="text-white fsize12 mb-0 pl-2"
                  :class="image3Source !== '' ? 'text-success' : ''"
                >
                  Upload an image in png,jpeg or jpg format.
                </p>
                <input
                  type="file"
                  class="opacity-0 absolute w-full h-full"
                  @change="uploadImage3"
                  :accept="['image/jpg', 'image/jpeg', 'image/png']"
                />
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ image3 === "" ? "This Field is required" : "" }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex gap-2 justify-center mt-12 bfix">
            <p
              @click="handleShift(false)"
              :class="[
                isshowform
                  ? 'bg-gray text-primary '
                  : 'bg-primary text-primary',
              ]"
              class="w-3 h-3 block cursor-pointer rounded-full"
            ></p>
            <p
              @click="handleShift(true)"
              :class="[
                isshowform
                  ? 'bg-primary text-primary '
                  : ' bg-gray text-primary ',
              ]"
              class="w-3 h-3 block bg-gray rounded-full cursor-pointer"
            ></p>
          </div>

          <div class="absolute bottom-0 margin-niche right-0">
            <div class="cursor-pointer">
              <div
                v-if="!clickOnce && isshowform"
                class="bg-primary w-24 h-24 rounded-full"
              >
                <div
                  class="flex justify-center items-center w-24 h-24"
                  @click="handleClick()"
                >
                  <feather-icon
                    icon="ArrowRightIcon"
                    svgClasses="w-10 h-10"
                    class="text-white flex"
                  />
                </div>
              </div>
              <div
                v-if="!clickOnce && !isshowform"
                class="bg-primary w-24 h-24 rounded-full"
              >
                <div
                  class="flex justify-center items-center w-24 h-24"
                  @click="handleShift(true)"
                >
                  <feather-icon
                    icon="ArrowRightIcon"
                    svgClasses="w-10 h-10"
                    class="text-white flex"
                  />
                </div>
              </div>
              <div
                v-if="clickOnce && !isshowform"
                class="bg-primary w-24 h-24 rounded-full"
              >
                <div class="flex justify-center items-center w-24 h-24">
                  <feather-icon
                    icon="ArrowRightIcon"
                    svgClasses="w-10 h-10"
                    class="text-white flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { VueEditor } from "vue2-quill-editor";
import URLTable from "@/views/adminPanel/pages/url/URL.vue";

export default {
  data() {
    return {
      templateName: "",
      subject: "",
      templateId: 2,
      isShowURL: false,
      body1:
        '<p>Hi,</p><p>Make your emails pop with an attractive banner. Make your emails pop with an attractive banner.</p><p><br></p><p>Make your emails pop with an attractive banner.<a href="https://brained.app/" target="_blank" style="color: rgba(var(--vs-primary), 1);">https://brained.app</a></p><p><br></p>',
      body2:
        '<p>Hi,</p><p>Make your emails pop with an attractive banner. Make your emails pop with an attractive banner.</p><p><br></p><p>Make your emails pop with an attractive banner.<a href="https://brained.app/" target="_blank" style="color: rgba(var(--vs-primary), 1);">https://brained.app</a></p><p><br></p>',
      isshowform: false,
      image1Change: false,
      image1: "",
      image1Source: "",
      image2Change: false,
      image2: "",
      image2Source: "",
      image3Change: false,
      image3: "",
      image3Source: "",
      increment: 0,
      submitted: false,
      checkform1: false,
      clickOnce: false,
    };
  },
  components: {
    VueEditor,
    URLTable,
  },
  computed: {
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("admin", { login: "login" }),
    ...mapState("marcom", ["taskListUsers"]),
    ...mapState("template", ["valueTemplate"]),
  },
  watch: {
    body1(newval) {
      if (newval === "<p><br></p>") {
        this.body1 = "";
      }
    },
    body2(newval) {
      if (newval === "<p><br></p>") {
        this.body1 = "";
      }
    },
    templateName() {
      this.whitespaceRemove();
    },
    subject() {
      this.whitespaceRemove();
    },
  },
  methods: {
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.templateName = this.templateName
          ? this.templateName.trimStart()
          : "";
        this.subject = this.subject ? this.subject.trimStart() : "";
        this.body1 = this.body1 ? this.body1.trimStart() : "";
      });
    },
    async uploadImage1(e) {
      this.image1Change = true;
      this.image1 = e.target.files[0];

      const reader = new FileReader();
      this.image1Source = await this.convertToBase64(e.target.files[0]);
      // console.log(this.image1Source);
    },
    async uploadImage2(e) {
      this.image2Change = true;
      this.image2 = e.target.files[0];

      const reader = new FileReader();
      this.image2Source = await this.convertToBase64(e.target.files[0]);
      // console.log(this.image1Source);
    },
    async uploadImage3(e) {
      this.image3Change = true;
      this.image3 = e.target.files[0];

      const reader = new FileReader();
      this.image3Source = await this.convertToBase64(e.target.files[0]);
      // console.log(this.image1Source);
    },
    convertToBase64(file) {
      return new Promise(async (resolve, reject) => {
        let reader = new FileReader();
        await reader.readAsDataURL(file);

        reader.onloadend = await function () {
          resolve(reader.result);
        };
      });
    },
    handleShift(show) {
      if (
        this.templateName !== "" &&
        this.subject !== "" &&
        (this.body1 !== "" || this.body1.length >= 35) &&
        (this.body2 !== "" || this.body2.length >= 35)
      ) {
        this.isshowform = show;
      }
      if (this.isshowform === true) {
        this.increment++;
      } else if (this.isshowform === false) {
        this.increment = 0;
        this.checkform1 = true;
      }
    },
    async handleClick() {
      if (
        this.templateName !== "" &&
        this.subject !== "" &&
        (this.body1 !== "" || this.body1.length >= 35) &&
        (this.body2 !== "" || this.body2.length >= 35) &&
        this.image !== "" &&
        this.image2 !== "" &&
        this.increment >= 1
      ) {
        this.clickOnce = true;
        this.submitted = true;
        const formData = new FormData();
        formData.append("projectId", this.selectedProject._id);
        formData.append("displayName", this.selectedProject.displayName);
        formData.append("projectName", this.selectedProject.projectName);
        formData.append("templateId", this.templateId);
        formData.append("templateName", this.templateName);
        formData.append("subject", this.subject);
        formData.append("body1", this.body1);
        formData.append("body2", this.body2);
        formData.append("image1", this.image1);
        formData.append("image2", this.image2);
        formData.append("image3", this.image3);
        formData.append("userId", this.login._id);
        formData.append("user", this.taskListUsers.PM[0]._id);

        let data = await this.$store.dispatch("controlCenter/create", formData);
        const res = await this.$swal({
          icon: "success",
          title: "Email Template Created Successfully",
          showConfirmButton: true,
        });
        console.log(res, "RES");
        if (res.isConfirmed) {
          this.clickOnce = false;
          let data = "Email";
          // this.$store.commit("template/TEMPLATE_VALUE_STORE", data);
          this.$router.push({ name: "settings-EmailTemplates" });
        }
      }
    },
  },
};
</script>
